/// <amd-module name="SuiteCommerce.Blog.PostSearch.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.PostSearch.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PostSearchModel = /** @class */ (function (_super) {
        __extends(PostSearchModel, _super);
        function PostSearchModel(options) {
            return _super.call(this, options) || this;
        }
        Object.defineProperty(PostSearchModel.prototype, "phrase", {
            get: function () {
                return this.get('phrase').replace(/[&=\/]*/g, '');
            },
            set: function (phrase) {
                this.set('phrase', phrase);
            },
            enumerable: true,
            configurable: true
        });
        return PostSearchModel;
    }(Backbone_1.Model));
    exports.PostSearchModel = PostSearchModel;
});
